import { FormControl, ValidationErrors } from "@angular/forms";
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { ValidatorsService } from "./validators.service";
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { take, debounceTime, switchMap, map, catchError, startWith } from 'rxjs/operators';

export function AlphaNumericValidator(control: FormControl): ValidationErrors {
  return !control.value || /^[a-zA-Z0-9]+$/.test(control.value) ? null : { 'alphaNumeric': true };
}

export function NumericValidator(control: FormControl): ValidationErrors {
  return !control.value || /(^[0-9]\d*$)/.test(control.value) ? null : { 'numeric': true };
}

export function EmailValidator(control: FormControl): ValidationErrors {
  return !control.value || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(control.value) ? null : { 'email': true };
}

export function currencyValidator(control: FormControl): ValidationErrors {
  return !control.value || /^[0-9.,]*$/.test(control.value) ? null : { 'numeric': true };
}

export function dateFutureValidator(control: FormControl, field: FormlyFieldConfig, options = {}): ValidationErrors {
  if (new Date(control.value) >= new Date()) {
    return { 'date-future': { message: 'Date cannot be in the future' } };
  }
}

export function AlphaNumericAndSpecialCharsValidator(control: FormControl): ValidationErrors {
  return !control.value || /^[a-zA-Z0-9\u2013\u002d().,'+\n\r\s]+$/.test(control.value) ? null : { 'alphanumericandspecialchars': true };
}

export function showError(field: FieldType) {
  return field.formControl && field.formControl.invalid && (field.formControl.touched || field.formControl.dirty || (field.options.parentForm && field.options.parentForm.submitted) || (field.field.validation && field.field.validation.show));
}


export function AsyncIbanValidator(control: FormControl, service: ValidatorsService): Observable<ValidationErrors | null> {
  if (!control.value || !control.valueChanges) return Observable.of(null);
  return control.valueChanges.pipe(
    startWith(control.value),
    debounceTime(1000),
    take(1),
    switchMap(value => service.validateIban(value)),
    map(response => response.valid ? null : { 'iban': true }),
    catchError(error => {
      console.error(error);
      return null;
    })
  );
}
